query UserDistributionLists {
  userDistributionLists(orderBy: [SEQUENCE_ID_ASC, SORT_ORDER_ASC]) {
    nodes {
      sequenceName
      groupId
      groupName
      userId
      userName
      isGroupHeader
      isGroupSelectable
      isDepartmentGroup
      departmentId
      isCommunicationGroup
      channelId
      isContactGroup
    }
  }
}
